module.exports = __webpack_public_path__ + "img/faq_boxed.a5371343.png";